import React from 'react';
import { Toaster, useToasterStore } from 'react-hot-toast';
import { TOAST_POSITION } from '../../constants';
import ToastWithProgress from '../ToastWithProgress/ToastWithProgress';

const AppToaster: React.FC = () => {
  const { pausedAt } = useToasterStore();

  return (
    <Toaster
      position={TOAST_POSITION}
      toastOptions={{
        duration: 5000,
        className: 'toast',
        style: {
          width: '400px',
          maxWidth: '400px',
          textAlign: 'center',
        },
      }}
    >
      {(t) => (
        <ToastWithProgress
          toast={t}
          pausedAt={pausedAt}
          position={TOAST_POSITION}
        />
      )}
    </Toaster>
  );
};

export default AppToaster;
